export const ratePlansTab = {
  sectionLabel: {
    title: "Rates shown in direct booking",
    hintHotel:
      "Choose which rates appear for each room type, their order and the default one.",
    hintApartment:
      "Choose which rates the guest sees, drag to reorder and mark the default.",
  },
  loading: "Loading rates…",
  empty: {
    apartment: "No rates set up for this property.",
    hotel: "No room types set up for this hotel.",
    room: "No rates set up for this room.",
  },
  derivedPill: "Derived",
  dragHandleTitle: "Drag to reorder",
  visibleSwitchTitle: "Show in direct booking",
  expandTitleClose: "Close settings",
  expandTitleOpen: "Set name, policy and default",
  visibleNameLabel: "Display name",
  visibleNamePlaceholderApartment: "E.g. Non-refundable / Flexible",
  visibleNamePlaceholderHotel: "E.g. Breakfast included",
  cond: {
    refundable: "Can be cancelled",
    refundableHint: "You decide how long it stays free.",
    nonRefundable: "Non-refundable",
    nonRefundableHint: "Nothing is refunded. Guests can still cancel, but they are charged 100%. They see this before paying.",
    freeDays: "Free cancellation until",
    freeDaysPlaceholder: "No limit",
    freeDaysHelp: "Days before arrival. Empty = free right up to arrival.",
    penalty: "After that you charge",
    penaltyHelp: "Of the total stay. 100% = nothing is refunded.",
    sinGuardar: "This rate has no saved conditions yet. What you see below is a suggestion — press “Save policy” to apply it.",
    aplicarTodas: "Apply to every room",
    aplicarTodasHelp: "The same condition will be set on the “{name}” rate of 1 more room. | The same condition will be set on the “{name}” rate of {count} more rooms.",
    notes: "Notes for the guest (optional)",
    previewNonRefundable: "Guests will read: “This rate is non-refundable: the booking cannot be cancelled.”",
    previewFree: "Guests will read: “Free cancellation until arrival.”",
    previewDayPenalty: "Guests will read: “Free cancellation until the day of arrival; after that you are charged {pct}%.”",
    previewUntilPenalty: "Guests will read: “Free until 1 day before; after that you are charged {pct}%.” | Guests will read: “Free until {count} days before; after that you are charged {pct}%.”",
    shortNonRefundable: "Non-refundable",
    shortFree: "Free cancellation",
    shortDayPenalty: "Free until arrival · then {pct}%",
    shortUntilPenalty: "Free until 1 day before · then {pct}% | Free until {count} days before · then {pct}%",
  },
  cancellationPolicyLabel: "Cancellation policy",
  policyEmpty: "No policy set",
  policyEdit: "Edit",
  policyAdd: "Add",
  defaultLabel: "Default",
  rulesApartment: "Rules: at least 1 visible and 1 default (which must be visible).",
  rulesRoom: "Each room must have at least 1 visible rate and 1 default.",
  tip: 'Tip: set a "Flexible" rate as the default and show others as "Non-refundable".',
  room: {
    ratePlansCount: "{count} rate | {count} rates",
    includedGuestsTitle: "How many guests the price includes (for the extra-guest charge)",
    includes: "Includes",
    person: "guest | guests",
    meta: "Capacity: {capacity} • Adults: {adults} • Children: {children}",
  },
  modal: {
    eyebrow: "Cancellation policy",
    closeAria: "Close",
    hint: "This text will be shown to the guest in direct booking. Describe the cancellation terms for this rate.",
    textareaPlaceholder:
      "E.g. Free cancellation up to 48h before check-in. After that, the first night is charged. Non-refundable in high season.",
    clear: "Clear",
    cancel: "Cancel",
    saving: "Saving…",
    save: "Save policy",
    defaultTitle: "Rate",
  },
  toasts: {
    loadError: "Couldn't load the rates.",
    saveSuccess: "Rates saved successfully.",
    saveError: "Couldn't save the rates.",
  },
  validation: {
    roomMinVisible: 'Room "{name}" must have at least 1 visible rate.',
    roomOneDefault: 'Room "{name}" must have exactly 1 default rate.',
    roomDefaultVisible: 'In "{name}", the default rate must be visible.',
    minVisible: "You must keep at least 1 visible rate.",
    oneDefault: "There must be exactly 1 default rate.",
    defaultVisible: "The default rate must be visible.",
  },
};
